export default __webpack_public_path__ + "static/media/Device.bd5ec5fc.svg";